export default __webpack_public_path__ + "static/media/elm.75e97545.jpg";